import { render, staticRenderFns } from "./ProductQuotasSection.vue?vue&type=template&id=52d0d5ca&scoped=true"
import script from "./ProductQuotasSection.vue?vue&type=script&lang=ts"
export * from "./ProductQuotasSection.vue?vue&type=script&lang=ts"
import style0 from "./ProductQuotasSection.vue?vue&type=style&index=0&id=52d0d5ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0d5ca",
  null
  
)

export default component.exports